const o = {
  iconWidth: 18
};
export {
  o as defaultProps
};
//# sourceMappingURL=const.mjs.map
